var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('tinymce-editor',{staticClass:"tinymce-editor",attrs:{"init":_vm.computedInit,"value":_vm.computedContent},on:{"input":function($event){return _vm.onInput($event)}}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }